export default "__VITE_ASSET__0fafa68e__"